import React, { useState, useEffect } from "react";
import styles from "./player.module.css";
import { Avatar, Stack, Pagination, Snackbar } from "@mui/material/";
import useAxiosPrivate from "../../utils/hooks/useAxiosPrivate";
import CloseIcon from "@mui/icons-material/Close";
import Alert from "@material-ui/lab/Alert";
import { Typography, Button } from "@material-ui/core";
import { ReactComponent as VisibilityIcon } from "../../utils/assets/visibilityIcon.svg";
import { ReactComponent as VisibilityIconBlue } from "../../utils/assets/visibilityIconBlue.svg";
import { ReactComponent as VisibilityOff } from "../../utils/assets/visibilityOff.svg";
import { ReactComponent as VisibilityOffBlue } from "../../utils/assets/visibilityOffBlue.svg";
import { DEFAULT_ALERT } from "utils/strings";

export default function Player() {
  const axios = useAxiosPrivate();
  const [members, setMembers] = useState([]);
  const [totalRecords, setTotalRecords] = useState();
  const [edit, setEdit] = useState(false);
  const [removeId, setRemoveId] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [count, setCount] = useState(0);
  const [active, setActive] = useState();
  const [alert, setAlert] = useState({
    showAlert: false,
    severity: "success",
    message: "",
  });

  useEffect(() => {
    loadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    loadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageNumber]);

  const handleRemove = (e) => {
    setRemoveId(e);
    setEdit(true);
  };

  const handleCancel = (e) => {
    setRemoveId(null);
    setEdit(false);
  };

  const loadData = async () => {
    try {
      const { data } = await axios.get(
        `/team/players?page=${pageNumber}&page_size=10`
      );
      setCount(data.total_pages);
      setTotalRecords(data.total_records);
      setMembers(
        data.data.sort(function (a) {
          if (a?.status.toLowerCase() === "active") {
            return -1;
          }
          return 0;
        })
      );
      setActive(data.active_records);
      setAlert(DEFAULT_ALERT);
    } catch (error) {
      setAlert({
        showAlert: true,
        severity: "error",
        message:
          "You're not in a Team yet. Please ask your team admin to invite you in.",
      });
    }
  };

  const handleDelete = async (memberId) => {
    try {
      await axios.delete(`/team/members/${memberId}`);
      loadData();
      setAlert({
        showAlert: true,
        severity: "success",
        message: "Player successfully deleted.",
      });
    } catch (error) {
      setAlert({
        showAlert: true,
        severity: "error",
        message: "Server error!",
      });
    }
  };

  const handleVisibility = async (memberId, visibility) => {
    try {
      await axios.post(`/team/player_visibility/${memberId}`, {
        visible: !visibility,
      });
      setMembers((prev) =>
        prev.map((item) => {
          if (item.member_id === memberId) {
            item.visible = !visibility;
          }
          return item;
        })
      );
    } catch (error) {
      setAlert({
        showAlert: true,
        severity: "error",
        message: "Server error!",
      });
    }
  };

  const handleChange = (event, value) => {
    setPageNumber(value);
  };

  const handleClose = () => {
    setAlert({
      showAlert: false,
      severity: "success",
      message: "",
    });
  };

  return (
    <div style={{ marginTop: "3.68rem" }}>
      <Snackbar
        open={alert.showAlert}
        autoHideDuration={4000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert severity={alert.severity} onClose={handleClose}>
          {alert.message}
        </Alert>
      </Snackbar>
      <div className={styles.container}>
        <div className={styles.searchBox}>
          <Typography
            variant="h5"
            style={{
              fontSize: "0.87rem",
              lineHeight: "1rem",
              marginBottom: "1%",
              color: "var(--primary-text-color)",
            }}
          >
            You have invited {totalRecords ? totalRecords : "--"} players.{" "}
            <span
              style={{
                fontFamily: "Poppins",
                fontWeight: "600",
                color: "var(--primary-theme-color)",
              }}
            >
              {active ? active : "--"}
            </span>{" "}
            players accepted your invitation.{" "}
          </Typography>
        </div>
      </div>
      <div className={styles.tableHead}>
        <div className={styles.header}>
          <div className={styles.tittle1}>
            <Typography
              variant="h5"
              style={{
                margin: "0 5px 0 0",
                fontSize: "0.78rem",
                lineHeight: "1rem",
                color: "var(--primary-text-color)",
              }}
            >
              Name
            </Typography>
          </div>
          <div className={styles.tittle2}>
            <Typography
              variant="h5"
              style={{
                margin: "0 5px 0 0",
                fontSize: "0.78rem",
                lineHeight: "1rem",
                color: "var(--primary-text-color)",
              }}
            >
              Email
            </Typography>
          </div>
          <div className={styles.tittle3}>
            <Typography
              variant="h5"
              style={{
                margin: "0 5px 0 0",
                fontSize: "0.78rem",
                lineHeight: "1rem",
                color: "var(--primary-text-color)",
              }}
            >
              Status
            </Typography>
          </div>
          <div className={styles.tittle3}>
            <Typography
              variant="h5"
              style={{
                margin: "0 5px 0 0",
                fontSize: "0.78rem",
                lineHeight: "1rem",
                color: "var(--primary-text-color)",
              }}
            >
              Visible on Dashboard
            </Typography>
          </div>
          <div className={styles.tittle3}>
            <Typography
              variant="h5"
              style={{
                margin: "0 5px 0 0",
                fontSize: "0.78rem",
                lineHeight: "1rem",
                color: "var(--primary-text-color)",
              }}
            >
              Remove
            </Typography>
          </div>
        </div>
      </div>
      {members.map((item, index) => (
        <div
          className={styles.container}
          style={{ cursor: "pointer" }}
          key={index}
        >
          <div
            className={`${styles.tBody} ${
              !item.visible ? styles.tBodyHidden : ""
            }`}
          >
            <div className={styles.tittle6}>
              <div className={styles.item2}>
                {" "}
                <Avatar
                  alt="Remy Sharp"
                  src={item.avatar_url}
                  sx={{ width: 30, height: 30 }}
                />
              </div>
              <div className={styles.item3}>
                {" "}
                <Typography
                  variant="h4"
                  style={{
                    fontSize: "0.69rem",
                    lineHeight: "1rem",
                    textTransform: "capitalize",
                    color: "var(--primary-text-color)",
                  }}
                >
                  {item?.first_name}&nbsp; {item?.last_name}
                </Typography>
              </div>
            </div>
            <div className={styles.tittle7}>
              <Typography
                variant="h6"
                style={{
                  fontSize: "0.69rem",
                  lineHeight: "1rem",
                  textTransform: "none",
                  color: "var(--primary-text-color)",
                }}
              >
                {item?.email}
              </Typography>
            </div>
            <div className={styles.tittle3}>
              <Typography
                variant="h4"
                style={{
                  fontSize: "0.69rem",
                  lineHeight: "1rem",
                  textTransform: "capitalize",
                  color: "var(--primary-text-color)",
                }}
              >
                {item?.status.toLowerCase()}
              </Typography>
            </div>
            <div className={styles.tittle3}>
              {edit && removeId === item?.member_id ? (
                <Button
                  variant="contained"
                  disableRipple
                  disableFocusRipple
                  className={styles.removeButton}
                  onClick={() => handleDelete(item?.member_id)}
                >
                  Remove
                </Button>
              ) : (
                <p className={styles.tdText}>
                  {item.visible ? (
                    item?.status.toLowerCase() === "active" ? (
                      <VisibilityIconBlue
                        className={styles.themeIcon}
                        onClick={() =>
                          handleVisibility(item.member_id, item.visible)
                        }
                      />
                    ) : (
                      <VisibilityIcon
                        style={{ width: "20px", height: "20px" }}
                        onClick={() =>
                          handleVisibility(item.member_id, item.visible)
                        }
                      />
                    )
                  ) : item?.status.toLowerCase() === "active" ? (
                    <VisibilityOffBlue
                      className={styles.themeIcon}
                      onClick={() =>
                        handleVisibility(item.member_id, item.visible)
                      }
                    />
                  ) : (
                    <VisibilityOff
                      style={{ width: "20px", height: "20px" }}
                      onClick={() =>
                        handleVisibility(item.member_id, item.visible)
                      }
                    />
                  )}
                </p>
              )}
            </div>
            <div className={styles.tittle3}>
              <p className={styles.tdText}>
                {edit && removeId === item?.member_id ? (
                  <Button
                    disableRipple
                    disableFocusRipple
                    className={styles.cancelButton}
                    onClick={() => handleCancel(item)}
                  >
                    Cancel
                  </Button>
                ) : (
                  <CloseIcon
                    className={styles.closeIcon}
                    onClick={() => handleRemove(item.member_id)}
                  />
                )}
              </p>
            </div>
          </div>
        </div>
      ))}
      <div className={styles.Pagination}>
        <Stack spacing={2}>
          <Pagination
            count={count}
            page={pageNumber}
            variant="outlined"
            shape="rounded"
            onChange={handleChange}
            style={{
              transform: "scale(0.8)",
            }}
          />
        </Stack>
      </div>
    </div>
  );
}
